import { HYDRATE } from "next-redux-wrapper";
import { ActionsMergeCart } from "./actions";

const initialState = { data: {}, status: "fetch_init", message: "" };

function storeMergeCarts(state = initialState, action) {

	switch (action.type) {

	case HYDRATE: {

		return { ...state, ...action.payload.storeMergeCarts };

	}
	case ActionsMergeCart.LOAD_GET_MERGE_CART:
		return { ...state, data: action.data, status: "fetch_loading" };
	case ActionsMergeCart.RES_GET_MERGE_CART:
		return { ...state, data: action.data, status: "fetch_result" };
	case ActionsMergeCart.ERR_GET_MERGE_CART:
		return {
			...state, data: action.data, status: "fetch_error", message: "Error...",
		};
	default: {

		return {
			...state,
		};

	}

	}

}

export default storeMergeCarts;
